import { render, staticRenderFns } from "./crmSidePanel.vue?vue&type=template&id=4ddd78ce&"
import script from "./crmSidePanel.vue?vue&type=script&lang=js&"
export * from "./crmSidePanel.vue?vue&type=script&lang=js&"
import style0 from "./crmSidePanel.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports